import { useEffect, useState, useRef } from "react";
import "./styles.sass";
import assets from "../../assets";
import {
  WELCOME_CARD,
  LANGUAGE_OPTIONS,
  LANGUAGE_OPTIONS_CBSE,
  LANGUAGE_TN_STATE_BOARD,
} from "../../utils/constant";
import { Conversation } from "../conversation";
import useHandler from "./handler";
import { ToggleButton } from "../toggle-button";
import LiveKitVideoPlayer from "../livekit-video";
import { Popup } from "../../neet-j2e/Pop-up";
import uiAssets from "../../assets";
import { MediaPopup } from "../../common-components/media-popup";

const LANGUAGE_MAP = {
  English: "en-IN",
  Bengali: "bn-IN",
  Gujarati: "gu-IN",
  Hindi: "hi-IN",
  Kannada: "kn-IN",
  Malayalam: "ml-IN",
  Marathi: "mr-IN",
  Punjabi: "pa-IN",
  Tamil: "ta-IN",
  Telugu: "te-IN",
  Urdu: "ur-IN",
};

export const ChatScreen = () => {
  const recognitionRef = useRef(null);
  const [isListening, setIsListening] = useState(false);
  const [fadeBubble, setFadeBubble] = useState(false);
  const chatBodyRef = useRef(null);
  const chatBottomRef = useRef(null);

  const {
    handleClearChat,
    handleNewChat,
    subjectRef,
    chapterRef,
    languageRef,
    conversation,
    selectedChapter,
    selectedSubject,
    selectedLanguage,
    openDropdown,
    inputText,
    classdetails,
    subjects,
    chapters,
    user,
    isStartEnabled,
    isEnable,
    isLoading,
    mode,
    selectedMedium,
    mediums,
    mediumRef,
    isHistoryEmpty,
    showPopup,
    assetData,
    scrollRef,
    popupMedia,
    audioRef,
    videoRef,
    inputRef,
    audioRes,
    videoRes,
    question,
    role,
    setQuestion,
    aiAudioChat,
    aiVideoChat,
    showAskBox,
    setShowAskBox,
    setPopupMedia,
    setShowPopup,
    onToggleBtn,
    getHistoryDetails,
    onClickStart,
    setSelectedChapter,
    setSelectedLanguage,
    setSelectedSubject,
    setOpenDropdown,
    setInputText,
    handleSend,
    handleKeyPress,
    onClickHistroy,
    onLiveAvatarApi,
    onEndAvatarInteraction,
    setSelectedMedium,
    onClickLearnVideo,
    videoMarkCompleted,
    avatarSession,
    avatarToast,
    isLiveAvatarLoading,
    downloadAvatarLog,
    lastAvatarSessionId,
  } = useHandler();

  const USER_LANGUGE =
    user?.data?.focus === "CBSE"
      ? LANGUAGE_OPTIONS_CBSE
      : LANGUAGE_TN_STATE_BOARD;

  useEffect(() => {
    // Double rAF ensures scroll happens after browser paint
    const raf1 = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (chatBodyRef.current) {
          chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
        }
      });
    });
    return () => cancelAnimationFrame(raf1);
  }, [conversation, isLoading]);

  const [isAvatarConnected, setIsAvatarConnected] = useState(false);

  useEffect(() => {
    if (!avatarSession) {
      setIsAvatarConnected(false);
    }
  }, [avatarSession]);

  // recognitionRef.onstart = () => setIsListening(true);
  // recognitionRef.onend = () => setIsListening(false);

  useEffect(() => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (SpeechRecognition) {
      const recognition = new SpeechRecognition();

      recognition.continuous = false;
      recognition.lang = LANGUAGE_MAP[selectedLanguage] || "en-IN";
      recognition.interimResults = false;

      recognition.onstart = () => setIsListening(true);
      recognition.onend = () => setIsListening(false);

      recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        setInputText(transcript);
        if (mode) {
          handleSend(transcript);
        }
      };

      recognition.onerror = (event) => {
        console.error("Speech recognition error", event);
        setIsListening(false);
      };

      recognitionRef.current = recognition;
    }
  }, [setInputText, selectedLanguage, mode]);

  const handleMicClick = () => {
    if (!recognitionRef.current) {
      alert("Speech Recognition not supported in this browser");
      return;
    }

    if (isListening) {
      recognitionRef.current.stop(); // stop if already listening
    } else {
      recognitionRef.current.start(); // start if not listening
    }
  };

  const renderWelComeCard = (item, index) => {
    const { title, description, emoji, accent } = item || {};
    return (
      <section
        key={index}
        className={`welcome_card welcome_card_${accent || "blue"}`}
      >
        <span className="welcome_card_icon_wrap">
          <span className="welcome_card_emoji">{emoji}</span>
        </span>
        <h5>{title}</h5>
        {description && <p className="welcome_card_desc">{description}</p>}
      </section>
    );
  };

  const lastUserMessage = conversation
    ?.filter((msg) => msg?.sender === "user")
    ?.pop()?.text;

  useEffect(() => {
    if (lastUserMessage) {
      setFadeBubble(false);
      const timer = setTimeout(() => {
        setFadeBubble(true);
      }, 15000);
      return () => clearTimeout(timer);
    }
  }, [lastUserMessage]);

  const LiveAvatarView = () => (
    <section className="live_avatar_container">
      <section className="video_player_wrapper">
        {!avatarSession ? (
          <div className="live_avatar_loading_wrapper">
            <section className="ai_wrapper">
              <img src={assets.ic_aitv} alt="aitv" />
              <p>Live Avatar</p>
            </section>
            <div className="tutor_logo_wrapper">
              <div className="wave_animation">
                <div className="wave"></div>
                <div className="wave"></div>
                <div className="wave"></div>
              </div>
              <img
                src={assets.ic_chat_moniter}
                alt="tutor_logo"
                className="tutor_img"
              />
            </div>
            <div className="loading_content">
              <p className="loading_text">Connecting to your AI tutor...</p>
              <p className="loading_subtitle">
                Setting up a secure video session...
              </p>
            </div>
            <div className="connecting_badge">
              <span className="badge_dot"></span>
              <span className="badge_text">Connecting...</span>
            </div>
          </div>
        ) : (
          <>
            <LiveKitVideoPlayer
              livekitUrl={avatarSession?.livekit_url}
              token={avatarSession?.livekit_client_token}
              onError={(err) => {
                console.error("Avatar streaming error:", err);
                onEndAvatarInteraction();
                alert("Connection to Avatar lost or invalid.");
              }}
              onConnected={() => setIsAvatarConnected(true)}
            />
            {lastUserMessage && (
              <div
                className={`last_question_bubble ${fadeBubble ? "fade_out" : ""}`}
              >
                <p>You: {lastUserMessage}</p>
              </div>
            )}
          </>
        )}
      </section>

      {/* Input area for Live Avatar */}
      {isAvatarConnected && (
        <section className="chat_footer avatar_input_footer">
          <section className="chat_input_wrapper">
            <input
              placeholder="Ask your question..."
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              onKeyDown={handleKeyPress}
              disabled={isLoading || !avatarSession}
            />
            <section className="mic_wrapper">
              <img
                src={assets.ic_mic}
                alt="ic_mic"
                className={`mic_icon ${isListening ? "listening" : ""}`}
                onClick={handleMicClick}
              />
              <img
                src={assets.ic_upload_btn}
                alt="send"
                className="send_icon"
                onClick={handleSend}
                disabled={isLoading || !avatarSession}
              />
              {(avatarSession?.session_id || lastAvatarSessionId) && (
                <button
                  className="download_transcript_btn"
                  onClick={downloadAvatarLog}
                >
                  Download Transcript
                </button>
              )}
            </section>
          </section>
        </section>
      )}
    </section>
  );

  const AssetCard = ({ data }) => {
    const {
      subject,
      chapter,
      title,
      topic,
      display_name,
      assets,
      language,
      description,
      content,
      hidden,
      id,
      url,
    } = data;
    const { audioUrl } = assets || {};

    const getAssetType = (url) => {
      if (!url) return "unknown";

      const lower = url?.toLowerCase();

      if (lower.includes(".mp4")) return "video";
      if (lower.includes(".mp3") || lower.includes(".wav")) return "audio";

      return "unknown";
    };

    const getTitleFromUrl = (url) => {
      const name = url.split("/").pop();
      return name.replace(/\.(mp4|mp3)/, "").replace(/-/g, " ");
    };

    const type = getAssetType(url);

    return (
      <section className="asset-popup-card">
        {type === "video" && (
          <video
            onContextMenu={(e) => e.preventDefault()}
            controlsList="nodownload"
            src={url}
            className="media-thumbnail"
            muted
            alt={topic}
            preload="metadata"
          />
        )}
        {type === "audio" && (
          <section className="audio-placeholder">
            <img src={uiAssets.img_bg} alt={topic} className="thumb" />
          </section>
        )}

        <section className="card-body">
          <h4>{title}</h4>
          <p className="meta">{description}</p>
          <section className="display-name">
            <button
              className="secondary-btn"
              onClick={() => {
                setPopupMedia({ ...data, type }); // ✅ add type here
                setShowAskBox(true);
                setShowPopup(false);
                // ✅ reset
              }}
            >
              <img src={uiAssets.ic_play} alt="play" />
              Play
            </button>
          </section>
          <p
            style={{
              textAlign: "center",
              marginTop: "4px",
              fontSize: "18px",
            }}
          >
            {display_name}
          </p>
        </section>
      </section>
    );
  };

  return (
    <section className="chat_layout">
      {avatarToast && (
        <div className="avatar_toast avatar_toast_error">
          <span className="avatar_toast_dot"></span>
          {avatarToast.message}
        </div>
      )}
      {/* LEFT CONTEXT */}
      <section className="nav_context_contanier">
        <section className="nav_learn_title">
          <h4>Learning Context</h4>
          <h6>Configure your learning session</h6>
        </section>

        <section className="nav_subject_details">
          <section className="board_wrapper">
            {classdetails?.data?.board === "CBSE" ||
            classdetails?.data?.board === "TN_STATE_BOARD" ? (
              <>
                <section className="board">
                  <h5>Board</h5>
                  <h4>{classdetails?.data?.board}</h4>
                </section>
                <section className="class">
                  <h5>Class</h5>
                  <h4>{classdetails?.data?.class}</h4>
                </section>
              </>
            ) : (
              <section className="class">
                <h5>Competitive Exam</h5>
                <h4>{classdetails?.data?.class}</h4>
              </section>
            )}
          </section>
        </section>

        <section className="chat_nav_mode_wrapper">
          <section className="chat_nav_mode_container">
            <h4>Learn Mode</h4>
            <ToggleButton isToggle={mode} onToggle={onToggleBtn} />
            <h4>Teach Mode</h4>
          </section>
        </section>

        <section className="quiz_default_medium_wrapper">
          <h4>Medium</h4>
          <h5>{user?.data?.medium}</h5>
        </section>

        <section className="nav_subject_wrapper">
          {/* MEDIUM */}
          {/* <section
            className="subject_wrapper"
            ref={mediumRef}
            onClick={() => setOpenDropdown("medium")}
          >
            <h4>Medium</h4>
            <section className="drop_down_wrapper">
              <p>{selectedMedium || "Select Medium"}</p>
              <img src={assets.ic_chevron_down} alt="" />
            </section>
            {openDropdown === "medium" && (
              <section className="options_list">
                {isLoading ? (
                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "35%",
                      color: "green",
                    }}
                  >
                    Loading mediums...
                  </p>
                ) : mediums?.length > 0 ? (
                  mediums?.map((item, i) => (
                    <p
                      key={i}
                      className="option_item"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedMedium(item);
                        setOpenDropdown(null);
                      }}
                    >
                      {item}
                    </p>
                  ))
                ) : (
                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "35%",
                      color: "red",
                    }}
                  >
                    No mediums found
                  </p>
                )}
              </section>
            )}
          </section> */}

          {/* SUBJECT */}
          <section
            className="subject_wrapper"
            ref={subjectRef}
            onClick={() => setOpenDropdown("subject")}
          >
            <h4>Subject</h4>
            <section className="drop_down_wrapper">
              <p>{selectedSubject || "Select Subject"}</p>
              <img src={assets.ic_chevron_down} alt="" />
            </section>
            {openDropdown === "subject" && (
              <section className="options_list">
                {
                  // !selectedMedium ? (
                  //   <p
                  //     style={{
                  //       textAlign: "center",
                  //       marginTop: "35%",
                  //       color: "green",
                  //     }}
                  //   >
                  //     Please first Choose Medium
                  //   </p>
                  // ) :
                  isLoading ? (
                    <p
                      style={{
                        textAlign: "center",
                        marginTop: "35%",
                        color: "green",
                      }}
                    >
                      Loading subjects...
                    </p>
                  ) : subjects.length > 0 ? (
                    subjects?.map((item, i) => (
                      <p
                        key={i}
                        className="option_item"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedSubject(item);
                          setOpenDropdown(null);
                        }}
                      >
                        {item}
                      </p>
                    ))
                  ) : (
                    <p
                      style={{
                        textAlign: "center",
                        marginTop: "35%",
                        color: "red",
                      }}
                    >
                      No subjects found
                    </p>
                  )
                }
              </section>
            )}
          </section>

          {/* CHAPTER */}
          <section
            className="subject_wrapper"
            ref={chapterRef}
            onClick={() => setOpenDropdown("chapter")}
          >
            <h4>Chapter</h4>
            <section className="drop_down_wrapper">
              <section className="selected_pills_container">
                {selectedChapter.length > 0 ? (
                  selectedChapter.map((item, index) => (
                    <div
                      key={index}
                      className="selected_tag"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <span>{item}</span>
                      <img
                        src={assets.ic_close_white}
                        alt="remove"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedChapter((prev) =>
                            prev.filter((c) => c !== item),
                          );
                        }}
                      />
                    </div>
                  ))
                ) : (
                  <p>Select Chapter</p>
                )}
              </section>
              <img
                src={assets.ic_chevron_down}
                alt=""
                className="chevron_icon"
              />
            </section>
            {openDropdown === "chapter" && (
              <section className="options_list">
                {!selectedSubject ? (
                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "35%",
                      color: "green",
                    }}
                  >
                    Please first Choose Subject
                  </p>
                ) : isLoading ? (
                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "35%",
                      color: "green",
                    }}
                  >
                    Loading chapters...
                  </p>
                ) : chapters?.length > 0 ? (
                  [
                    "All Chapters",
                    ...chapters.filter((c) => c !== "All Chapters"),
                  ]?.map((item, i) => (
                    <section
                      key={i}
                      className="option_item"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedChapter((prev) => {
                          if (item === "All Chapters") {
                            return prev.includes("All Chapters")
                              ? []
                              : ["All Chapters"];
                          }
                          const filtered = prev.filter(
                            (c) => c !== "All Chapters",
                          );
                          return filtered.includes(item)
                            ? filtered.filter((c) => c !== item)
                            : [...filtered, item];
                        });
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "10px",
                      }}
                    >
                      <p style={{ margin: 0 }}>{item}</p>
                      {selectedChapter.includes(item) ? (
                        <img
                          src={assets.ic_checkbox_tick}
                          alt="selected"
                          style={{ width: "16px", height: "16px" }}
                        />
                      ) : (
                        <img
                          src={assets.ic_uncheckbox}
                          alt="not-selected"
                          style={{ width: "16px", height: "16px" }}
                        />
                      )}
                    </section>
                  ))
                ) : (
                  <p className="option_item">No chapters found</p>
                )}
                {/* {selectedSubject == "" && <p style={{textAlign:"center",marginTop:"35%",color:"green"}}>Please first Choose Subject</p>}
                  {} */}
              </section>
            )}
          </section>

          {/* LANGUAGE */}
          <section
            className="subject_wrapper"
            ref={languageRef}
            onClick={() => setOpenDropdown("language")}
          >
            <h4>Language</h4>
            <section className="drop_down_wrapper">
              <p>{selectedLanguage || "Select Language"}</p>
              <img src={assets.ic_chevron_down} alt="" />
            </section>
            {openDropdown === "language" && (
              <section className="options_list">
                {LANGUAGE_TN_STATE_BOARD.map((item, i) => (
                  <p
                    key={i}
                    className="option_item"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedLanguage(item);
                      setOpenDropdown(null);
                    }}
                  >
                    {item}
                  </p>
                ))}
              </section>
            )}
          </section>
          {!mode && (
            <button
              className="starts_learn_wrapper"
              disabled={!isStartEnabled}
              onClick={onClickLearnVideo}
            >
              Start Learning
            </button>
          )}
          {!mode && (
            <button
              className="starts_chart_wrapper"
              disabled={!isStartEnabled}
              onClick={onClickStart}
            >
              Ask Question
            </button>
          )}

          {showPopup && (
            <Popup isOpen={showPopup} onClose={() => setShowPopup(!showPopup)}>
              <section className="chat_popup">
                <img
                  src={assets.ic_video_blue}
                  alt="video"
                  width={56}
                  height={56}
                />
                <div className="chat_heading">
                  <h3>Video Assets</h3>
                  {assetData?.length ? (
                    <div className="chat_details">
                      <p>{assetData?.length} videos</p>
                      <section className="dot_seperator"></section>
                      <p>Generated by Rovian Learning AI</p>
                    </div>
                  ) : (
                    "No asset found for given filter"
                  )}
                </div>
              </section>
              {/* <section className="asset_popup">
                <section className="asset_popup_inner" ref={scrollRef}>
                  {assetData?.urls?.map((item, index) => (
                    <AssetCard key={index} data={{ url: item }} />
                  ))}
                </section>
              </section> */}

              <section className="asset_popup">
                <section className="asset_popup_inner" ref={scrollRef}>
                  {assetData?.map((item, index) => (
                    <AssetCard
                      key={index}
                      data={{
                        url: item?.url,
                        display_name: item?.display_name,
                      }}
                    />
                  ))}
                </section>
              </section>
            </Popup>
          )}

          {!mode && (
            <button
              className="history_wrapper_card"
              disabled={!isStartEnabled}
              onClick={getHistoryDetails}
            >
              <img
                src={assets.ic_history}
                alt="history"
                className="history_ic"
              />
              Previous Learnings
            </button>
          )}
          {mode && (
            <button
              className="history_wrapper_card"
              style={
                avatarSession
                  ? { backgroundColor: "#ef4444", color: "white" }
                  : {}
              }
              disabled={!isStartEnabled}
              onClick={avatarSession ? onEndAvatarInteraction : onLiveAvatarApi}
            >
              {avatarSession ? "End Interaction" : "Interact with Avatar"}
            </button>
          )}
        </section>
      </section>

      {/* CHAT PANEL */}
      <section className="chat_panel">
        <section className="profile_header_wrapper">
          <section className="profile_details_section">
            <img src={assets.ic_profile_moniter} alt="" />
            <div>
              <h4>{user?.data?.name ? user?.data?.name : "Rovian AI Tutor"}</h4>
              <h6>Online</h6>
            </div>
          </section>
          <section className="clear_wrapper">
            <button className="clear_chat_wrapper" onClick={handleClearChat}>
              <img src={assets.ic_refresh} alt="refresh" />
              Clear Chat
            </button>
            <button
              className="new_chat_card"
              disabled={!isEnable}
              onClick={handleNewChat}
            >
              <img src={assets.ic_add_circle} alt="refresh" />
              New Chat
            </button>
          </section>
        </section>

        <section
          className={`chat_body ${mode ? "full_width" : ""}`}
          ref={chatBodyRef}
        >
          {conversation.length === 0 && !isHistoryEmpty ? (
            <section className="welcome_content_wrapper">
              <section className="ai_content">
                <section className="ai_wrapper">
                  <img src={assets.ic_aitv} alt="aitv" />
                  <p>{mode ? "Live Avatar" : "Rovian AI Chatbot"}</p>
                </section>
                <section className="welcome_assist_wrapper">
                  <h2>Welcome to Your AI Learning Assistant!</h2>
                  <h5>
                    Choose what you want to learn today from the left panel. I'm
                    here to help you understand any topic, answer your
                    questions, and guide you through your studies.
                  </h5>
                </section>
              </section>
              <section className="welcome_card_wrapper">
                {WELCOME_CARD.map(renderWelComeCard)}
              </section>
              <section className="get_start">
                <h6>
                  👈 Get started by selecting your subject, chapter, and
                  language
                </h6>
              </section>
            </section>
          ) : mode && (avatarSession || isLiveAvatarLoading) ? (
            LiveAvatarView()
          ) : isHistoryEmpty ? (
            <section className="no_history_wrapper">
              <h4>No History Found</h4>
            </section>
          ) : (
            <Conversation
              convo={conversation}
              subject={selectedSubject}
              chapter={selectedChapter}
              mode={mode}
              medium={selectedMedium}
            />
          )}
          <div ref={chatBottomRef} style={{ height: 0, flexShrink: 0 }} />
        </section>

        {popupMedia && (
          <MediaPopup
            data={popupMedia}
            onClose={() => {
              setPopupMedia(null);
              setShowAskBox(false);
            }}
            audioRef={audioRef}
            videoRef={videoRef}
            showAskBox={showAskBox}
            setShowAskBox={setShowAskBox}
            question={question}
            setQuestion={setQuestion}
            inputRef={inputRef}
            audioRes={audioRes}
            videoRes={videoRes}
            aiAudioChat={aiAudioChat}
            aiVideoChat={aiVideoChat}
            markVideo={videoMarkCompleted}
            role={role}
          />
        )}

        {!mode && isEnable && (
          <section className="chat_footer">
            <section
              className={`chat_input_wrapper ${isLoading ? "disabled" : ""}`}
            >
              <input
                placeholder={
                  isLoading ? "AI is thinking..." : "Ask me anything..."
                }
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
                onKeyDown={handleKeyPress}
                disabled={isLoading}
              />
              <section className="mic_wrapper">
                <img
                  src={assets.ic_mic}
                  alt="ic_mic"
                  className={`mic_icon ${isListening ? "listening" : ""} ${isLoading ? "disabled" : ""}`}
                  onClick={!isLoading ? handleMicClick : undefined}
                />
                <img
                  src={assets.ic_upload_btn}
                  alt="send"
                  className={`send_icon ${isLoading ? "disabled" : ""}`}
                  onClick={!isLoading ? handleSend : undefined}
                  disabled={!isEnable || isLoading}
                />
                {(avatarSession?.session_id || lastAvatarSessionId) && (
                  <button
                    className="download_transcript_btn"
                    onClick={downloadAvatarLog}
                  >
                    Download Transcript
                  </button>
                )}
              </section>
            </section>
          </section>
        )}
      </section>
    </section>
  );
};
